import { ElementRef, EventEmitter } from '@angular/core';
var AchooPopupComponent = /** @class */ (function () {
    function AchooPopupComponent() {
        this.acceptCallback = new EventEmitter();
        this.cancelCallback = new EventEmitter();
        // this callback will useful when the cancel callback is different from close callback for "X" icon
        this.closeCallback = new EventEmitter();
        this.isNotification = false;
        this.isRoiSettingPopup = false;
        this.isTermAndCondPopup = false;
    }
    AchooPopupComponent.prototype.onAccept = function (event) {
        this.acceptCallback.emit(event);
    };
    AchooPopupComponent.prototype.onCancel = function (event) {
        this.cancelCallback.emit(event);
    };
    AchooPopupComponent.prototype.onClose = function (evt) {
        if (this.closeCallback.observers.length > 0) {
            this.closeCallback.emit(evt);
        }
        else {
            this.onCancel(evt);
        }
    };
    Object.defineProperty(AchooPopupComponent.prototype, "shouldShowCloseIcon", {
        get: function () {
            return this.closeCallback.observers.length > 0 || this.cancelCallback.observers.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    return AchooPopupComponent;
}());
export { AchooPopupComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-popup/achoo-popup.component.ts.pre-build-optimizer.js